// 定义常见意义上连续的每一行的数据
const continuousLines = [
  ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'],
  [
    'aA',
    'bB',
    'cC',
    'dD',
    'eE',
    'fF',
    'gG',
    'hH',
    'iI',
    'jJ',
    'kK',
    'lL',
    'mM',
    'nN',
    'oO',
    'pP',
    'qQ',
    'rR',
    'sS',
    'tT',
    'uU',
    'vV',
    'wW',
    'xX',
    'yY',
    'zZ'
  ]
]
// 定义键盘上每一行的数据
const keyboardLines = [
  ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'],
  ['qQ', 'wW', 'eE', 'rR', 'tT', 'yY', 'uU', 'iI', 'oO', 'pP'],
  ['aA', 'sS', 'dD', 'fF', 'gG', 'hH', 'jJ', 'kK', 'lL'],
  ['zZ', 'xX', 'cC', 'vV', 'bB', 'nN', 'mM']
]
/**
 * 不可存在连续字符，密码不得包含键盘上任意连续的 CONTINUOUS_NUM 个字符或shift转换字符
 */
const CONTINUOUS_NUM = 5

const validContinuous = password => {
  const continuousKeys = []
  let flag = true
  password.split('').forEach(character => {
    continuousKeys.push(character)
    if (continuousKeys.length === CONTINUOUS_NUM) {
      if (isContinuous(continuousKeys)) {
        flag = false
      }
      continuousKeys.shift()
    }
  })
  return flag
}
/**
 * 判断是否为连续的键位
 *
 * @param keys 键位
 * @return 是否是一行上连续的5个键位
 */
const isContinuous = keys => {
  // 是否在一行
  const lines = continuousLines.concat(keyboardLines)
  let isInLine = false
  let list = []
  lines.forEach(line => {
    if (keys.every(ele => line.find(item => ~item.indexOf(ele)))) {
      isInLine = true
      list = line
    }
  })
  if (!isInLine) {
    return false
  }

  // 是否升序
  let isAsc = true
  for (let i = 0; i < keys.length - 1; i++) {
    if (
      list.findIndex(ele => ele.includes(keys[i])) + 1 !=
      list.findIndex(ele => ele.includes(keys[i + 1]))
    ) {
      isAsc = false
    }
  }
  return isAsc
}

// 判读连续重复字符是否超过5个
const isRepeat = str => {
  let k = 0,
    j = 1
  let num = 1
  let obj = {} // 用来记录每一个字符及其出现的次数

  for (let i = 0; i < str.length; i++) {
    if (str[j] === str[k]) {
      num += 1
    } else {
      obj[str[k]] = num
      k = j
      num = 1
    }
    j += 1
  }

  let maxNum = 5
  let flag = false
  for (let key in obj) {
    if (obj[key] >= maxNum) {
      flag = true
    }
  }
  return flag
}

export const validPwd = (rule, value, callback) => {
  // (?![a-zA-Z]+$) 断言不是全部由大小写字母组成（即必须有0-9）
  // (?![0-9A-Z]+$) 断言不是全部由0-9、大写字母组成（即必须有小写字母）
  // (?![0-9a-z]+$) 断言不是全部由0-9、小写字母组成（即必须有大写字母）
  const reg = /^(?![a-zA-Z]+$)(?![0-9A-Z]+$)(?![0-9a-z]+$)[0-9a-zA-Z]{8,16}$/
  if (value.match(reg) == null) {
    callback(new Error('限制8-16位字符，必须是大小写字母、数字的组合!'))
  } else if (!validContinuous(value)) {
    callback(
      new Error(
        '不可存在连续字符，密码不得包含键盘上任意连续的五个字符或shift转换字符'
      )
    )
  } else if (isRepeat(value)) {
    callback(new Error('不可存在相同字符（如11111、aaaaa）连续5位或5位以上'))
  } else {
    callback()
  }
}
